module.exports = __webpack_public_path__ + "img/bule8.b8479385.png";